<template>
  <div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <ImageUploader ref="imageUploader" defaultImage="http://localhost:4017/8/4/2/7/1/84271604-639a-4191-a219-3fa375626a62.jpg" />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <button type="button" class="btn btn-info" @click="fetchImages">
            Get Image
          </button>
          {{ images }}
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <BranchSelect v-model:selectedBranch="selectedBranch" />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          {{ selectedBranch }}
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <PaymentTypeMultiselect v-model:payments="payments" />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <div class="App__form-item">
            <button type="button" class="btn btn-info" @click="fetchPayments">
              Get Payments
            </button>
            {{ payments }}
          </div>
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <AddressForm v-model:address="addressForm" />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <div class="App__form-item">
            {{ addressForm }}
          </div>
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <Dropzone
            class="dropzone"
            ref-key="imageRef"
            :options="{
              url: 'http://localhost:4010/api/v1/admin/cdn/upload',
              uploadOnDrop: true,
              maxFiles: 1,
              thumbnailWidth: 150,
              maxFilesize: 3,
              headers: authHeaderValue
            }"
          />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <div class="App__form-item">
            <label for="image">Image</label>
            <input :value="imageUrl" name="image" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <LocationSelector v-model:selectedLocation="selectedLocation" />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <button type="button" class="btn btn-info" @click="fetchAddress">
            Get address
          </button>

          <div class="App__form-item">
            <label for="street">Street</label>
            <input :value="address.road" name="street" class="form-control" />
          </div>

          <div class="App__form-item">
            <label for="street_number">Street number</label>
            <input
              :value="address.house_number"
              name="street_number"
              class="form-control"
            />
          </div>

          <div class="App__form-item">
            <label for="postalcode">Postalcode</label>
            <input
              :value="address.postcode"
              name="postalcode"
              class="form-control"
            />
          </div>

          <div class="App__form-item">
            <label for="town">Town</label>
            <input :value="address.town" name="town" class="form-control" />
          </div>

          <div class="App__form-item">
            <label for="country">Country</label>
            <input
              :value="address.country"
              name="country"
              class="form-control"
            />
          </div>
          <div class="App__form-item">
            <label for="latitude">Latitude</label>
            <input
              :value="selectedLocation.coordinate[1]"
              name="latitude"
              class="form-control"
            />
          </div>
          <div class="App__form-item">
            <label for="longitude">Longitude</label>
            <input
              :value="selectedLocation.coordinate[0]"
              name="longitude"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <Calendar />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5"></div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <AddressSelector v-model:address="addressSelectorData" />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <div class="App__form-item">
            {{ addressSelectorData }}
          </div>
        </div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="col-span-12 lg:col-span-8">
        <div class="intro-y box p-5">
          <OpenHoursForm
            v-model:openHours="openHours"
            ref="openHoursComponent"
          />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <div class="intro-y box p-5">
          <div class="App__form-item">
            <button @click="setOpenHours">SET</button>
            {{ openHours }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, provide, onMounted } from 'vue'
import axios from 'axios'
import AddressForm from '../../components/address/AddressForm.vue'
import LocationSelector from '../../components/openstreetmap/LocationSelector.vue'
import AddressSelector from '../../components/openstreetmap/AddressSelector.vue'
import Calendar from '../../components/reservations/Calendar.vue'
import authHeader from '@/services/security/auth.header'
import OpenHoursForm from '@/components/branches/OpenHoursForm.vue'
import ImageUploader from '@/components/cdn/ImageUploader.vue'
import PaymentTypeMultiselect from '../../components/payments/PaymentTypeMultiselect.vue'
import BranchSelect from '@/components/branches/BranchSelect.vue'

export default defineComponent({
  components: {
    ImageUploader,
    PaymentTypeMultiselect,
    AddressForm,
    LocationSelector,
    AddressSelector,
    Calendar,
    OpenHoursForm,
    BranchSelect
  },
  computed: {
    console: () => console
  },
  methods: {
    fetchImages() {
      console.info(this.$refs.imageUploader.getValue())
      this.images = this.$refs.imageUploader.getValue()
    },
    fetchPayments() {
      console.log(this.payments)
    },
    setOpenHours() {
      this.$refs.openHoursComponent.setData({
        openMonday: true,
        monday: '',
        openTuesday: true,
        tuesday: '',
        openWednesday: true,
        wednesday: '10:00-20:00',
        openThursday: true,
        thursday: '10:00-20:00',
        openFriday: true,
        friday: '10:00-20:00',
        openSaturday: false,
        saturday: '',
        openSunday: true,
        sunday: ''
      })
    },
    fetchAddress() {
      if (undefined === this.selectedLocation) {
        return
      }
      axios
        .get('https://nominatim.openstreetmap.org/reverse', {
          params: {
            format: 'jsonv2',
            lat: this.selectedLocation.coordinate[1],
            lon: this.selectedLocation.coordinate[0]
          }
        })
        .then(
          response => {
            this.address = response.data.address
          },
          error => {
            console.log(error)
          }
        )
    }
  },
  setup() {
    const selectedLocation = ref({
      coordinate: ['', '']
    })
    const address = ref({})
    const addressForm = ref({})
    const payments = ref([])
    const images = ref([])

    const openHours = ref({
      openMonday: true,
      monday: '10:00-20:00',
      openTuesday: true,
      tuesday: '10:00-20:00',
      openWednesday: true,
      wednesday: '10:00-20:00',
      openThursday: true,
      thursday: '10:00-20:00',
      openFriday: true,
      friday: '10:00-20:00,22:00-23:00',
      openSaturday: false,
      saturday: '',
      openSunday: true,
      sunday: ''
    })

    const imageRef = ref()
    const imageUrl = ref()

    const addressSelectorData = ref({})

    const selectedBranch = ref({})

    const authHeaderValue = authHeader()

    provide('bind[imageRef]', el => {
      imageRef.value = el
    })

    onMounted(() => {
      const elDropzoneSingleRef = imageRef.value
      elDropzoneSingleRef.dropzone.on('success', items => {
        console.log(JSON.parse(items.xhr.response).data[0].uri)
        imageUrl.value = JSON.parse(items.xhr.response).data[0].uri
      })
      elDropzoneSingleRef.dropzone.on('error', (files, error) => {
        console.log(files)
        console.log(error)
      })
    })

    return {
      selectedLocation,
      images,
      address,
      imageUrl,
      authHeaderValue,
      addressForm,
      addressSelectorData,
      openHours,
      payments,
      selectedBranch
    }
  }
})
</script>
